import _ from 'lodash';
import AurCountryFlag from '../common/aur-country-flag/AurCountryFlag';
import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

type HostCountryDetailsProps = {
  domainCountryCode?: string;
  dataCenterName?: string;
  countryName?: string;
};

const HostCountryDetails: FC<HostCountryDetailsProps> = ({
  domainCountryCode = '',
  dataCenterName = '',
  countryName = '',
}) => {
  return (
    <Box className="aur-host-country-details">
      <Box>
        <Typography component="span" className="typo-text body4_size">
          {t('addEditTeamMember.form.hostingLocation')}
        </Typography>
        {!_.isEmpty(countryName) ? (
          <Typography component="span" className="typo-text body4_size">
            <AurCountryFlag
              countryCode={domainCountryCode}
              altText={countryName}
            />
            <Typography
              component="span"
              className="country-name typo-text body4_size"
            >
              {countryName}
            </Typography>
          </Typography>
        ) : (
          <Typography component="span" className="typo-text body4_size">
            --
          </Typography>
        )}
      </Box>

      <Box>
        <Typography component="span" className="typo-text body4_size">
          {t('addEditTeamMember.form.dataCenter')}
        </Typography>
        <Typography component="span" className="typo-text body4_size">
          {!_.isEmpty(dataCenterName) ? dataCenterName : '--'}
        </Typography>
      </Box>
    </Box>
  );
};

export default HostCountryDetails;
